import React, { FC } from "react";
import "./Main.scss";

const Main: FC = ({ children }) => {
  return <main className="main">{children}</main>;
};

export default Main;
